import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { AccountMergeDataset } from './account.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.Customer,
})
export class CustomerMergeDataset extends AccountMergeDataset {
}